import React from 'react';


export const ListContext = React.createContext({
  role: 'listbox',
});

export const ItemContext = React.createContext({
  disabled: false
});
